import { useFormContext } from "react-hook-form";
import { CFormCheck } from "@coreui/react";

import { MapPin, Wallet } from "lucide-react";
import BoxWrapper from "../../../components/BoxWrapper";

import { ActivityFormValues } from "../../../helpers/types";
import { PaymentOptions } from "../../../helpers/enums";
import { WafacashIcon } from "../../../components/icons/WafaCashIcon";
import { CreditCardIcon } from "../../../components/icons/CreditCardIcon";

interface PaymentChoice {
  value: string;
  label: string;
  icon: React.ReactNode;
}

const PAYMENT_METHOD_CHOICES: PaymentChoice[] = [
  {
    value: PaymentOptions.CREDIT_CARD,
    label: "Carte bancaire",
    icon: <CreditCardIcon width={30} height={30} />,
  },
  {
    value: PaymentOptions.STRIPE,
    label: "Paiement en Euro (Stripe)",
    icon: <CreditCardIcon width={30} height={30} color="#003399" />,
  },
  {
    value: PaymentOptions.WAFACASH,
    label: "Wafacash",
    icon: <WafacashIcon width={30} height={30} />,
  },
  {
    value: PaymentOptions.USER_BALANCE,
    label: "Solde du portefeuille",
    icon: <Wallet size={30} />,
  },
  {
    value: PaymentOptions.IN_PLACE,
    label: "Paiement sur place",
    icon: <MapPin size={30} />,
  },
];

export default function PaymentMethods() {
  const { watch, setValue } = useFormContext<ActivityFormValues>();
  const selected = (watch("paymentMethods") || []) as string[];

  const toggleMethod = (value: string) => {
    const next: string[] = selected.includes(value)
      ? selected.filter((m) => m !== value)
      : [...selected, value];

    setValue("paymentMethods", next, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <BoxWrapper>
      <section className="p-4">
        <h5 className="mb-1">Méthodes de paiement acceptées</h5>
        <p className="text-muted small mb-4">
          Sélectionnez les moyens de paiement que les clients pourront utiliser
          pour réserver cette activité.
        </p>

        <div className="d-flex flex-column gap-2">
          {PAYMENT_METHOD_CHOICES.map((choice) => {
            const isChecked = selected.includes(choice.value);
            return (
              <label
                key={choice.value}
                className={`d-flex align-items-center gap-3 p-3 border rounded-3 ${
                  isChecked
                    ? "border-warning bg-warning-subtle"
                    : "border-secondary-subtle"
                }`}
                style={{ cursor: "pointer" }}
              >
                <CFormCheck
                  checked={isChecked}
                  onChange={() => toggleMethod(choice.value)}
                  className="m-0"
                />
                <span
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: 28 }}
                >
                  {choice.icon}
                </span>
                <span className="fw-semibold">{choice.label}</span>
              </label>
            );
          })}
        </div>

        {selected.length === 0 && (
          <div className="text-danger small mt-3">
            Veuillez sélectionner au moins une méthode de paiement.
          </div>
        )}
      </section>
    </BoxWrapper>
  );
}
